import moment from "moment";

class DateUtils {
    public static toStartDayTimestamp(date: Date): number {
        return moment(date).set({ hour: 0, minute: 0, second: 0, millisecond: 0 }).unix();
    }

    public static toEndDayTimestamp(date: Date): number {
        return moment(date).set({ hour: 23, minute: 59, second: 59, millisecond: 999 }).unix();
    }

    public static toDate(timestamp: number): Date {
        return moment.unix(timestamp).toDate();
    }

    public static toFormat(timestamp: number, format = "DD MMM Y HH:mm"): string {
        return moment(timestamp * 1000).format(format);
    }

    public static getCurrentTimestamp(): number {
        return Math.floor(Date.now() / 1000);
    }

    public static getCurrentDate(): string {
        return moment(Date.now()).format("DD/MM/YYYY");
    }

    public static getTimestampTillMidnight() {
        const now = new Date();
        const midnight = new Date(now);
        midnight.setHours(24, 0, 0, 0);
        return Math.floor((midnight.getTime() - now.getTime()) / 1000);
    }

    public static formatDate(date: Date | null) {
        if (!date) return "N/A";
        const day = date.getDate();
        const month = date.getMonth() + 1;
        const year = date.getFullYear();

        return `${year}/${month}/${day}`;
    }

    public static formatIsoDate(isoDate: string): string {
        return moment(isoDate).format("DD-MM-YYYY");
    }
}

export default DateUtils;
